import React from 'react';
import { Box, Typography, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import {
  HourglassEmpty, Timer, Schedule, TouchApp,
  Inventory, FactCheck,
  QrCodeScanner, CameraAlt, Description, Search, Numbers,
} from '@mui/icons-material';
import { useMissionBuilder, TRIGGER_BLOCKS, MISSION_BLOCKS, STEP_BLOCKS, createBlock } from '../MissionBuilderContext';

const ICONS: Record<string, React.ReactNode> = {
  HourglassEmpty: <HourglassEmpty />,
  Timer: <Timer />,
  Schedule: <Schedule />,
  TouchApp: <TouchApp />,
  Inventory: <Inventory />,
  FactCheck: <FactCheck />,
  QrCodeScanner: <QrCodeScanner />,
  CameraAlt: <CameraAlt />,
  Description: <Description />,
  Search: <Search />,
  Numbers: <Numbers />,
};

function PaletteSection({ title, items, color }: { title: string; items: typeof TRIGGER_BLOCKS; color: string }) {
  const { addBlock, blocks } = useMissionBuilder();

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="overline" sx={{ px: 1.5, color: 'text.secondary', fontWeight: 700, letterSpacing: 1.5 }}>
        {title}
      </Typography>
      <List dense disablePadding>
        {items.map((item) => {
          const alreadyAdded =
            (item.category === 'trigger' && blocks.some((b) => b.category === 'trigger')) ||
            (item.category === 'mission' && blocks.some((b) => b.category === 'mission'));

          return (
            <ListItemButton
              key={item.type}
              disabled={alreadyAdded}
              onClick={() => addBlock(createBlock(item))}
              sx={{
                borderRadius: 1.5,
                mx: 0.5,
                my: 0.25,
                '&:hover': { bgcolor: `${color}10` },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color }}>
                {ICONS[item.icon]}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
              />
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
}

export function BlockPalette() {
  return (
    <Box sx={{ p: 1, height: '100%', overflow: 'auto' }}>
      <Typography variant="subtitle2" sx={{ px: 1.5, pb: 1, fontWeight: 700 }}>
        Block Palette
      </Typography>
      <PaletteSection title="Triggers" items={TRIGGER_BLOCKS} color="#7c3aed" />
      <PaletteSection title="Mission Type" items={MISSION_BLOCKS} color="#0891b2" />
      <PaletteSection title="Steps" items={STEP_BLOCKS} color="#059669" />
    </Box>
  );
}
